import { render, staticRenderFns } from "./BusinessDashboard.vue?vue&type=template&id=2e0611d0&scoped=true"
import script from "./BusinessDashboard.vue?vue&type=script&lang=js"
export * from "./BusinessDashboard.vue?vue&type=script&lang=js"
import style0 from "./BusinessDashboard.vue?vue&type=style&index=0&id=2e0611d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0611d0",
  null
  
)

export default component.exports